import { Popup, Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setIsDeactivateEmployeeConfirmationModalOpen } from "./DeactivateEmployeeConfirmationModalSlice";
import { deactivateEmployee } from "../../common/utils/deactivateEmployee";
import { useDeactivateMutation } from "../../common/api/employee";
import { FormEvent, JSX, useEffect, useState } from "react";
import {
    setIsPatchDeactivateEmployeeSuccess,
    setIsPatchDeactivateEmployeeIsLoading,
} from "./DeactivateEmployeeConfirmationModalSlice";
import { useEstablishmentId } from "../../common/utils/useEstablishmentId";
import { DateInputFieldComponent } from "../../common/components/DateInputFieldComponent";

const getTodayDateString = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const DeactivateEmployeeConfirmationModalContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { deactivatedEmployee } = useAppSelector(
        (state) => state.deactivateEmployeeConfirmationModal,
    );
    const establishmentId = useEstablishmentId();
    const [outOfServiceDate, setOutOfServiceDate] =
        useState<string>(getTodayDateString);

    const [
        postEmployeeDeactivate,
        {
            isSuccess: isPatchDeactivateEmployeeSuccess,
            isLoading: isPatchDeactivateEmployeeIsLoading,
        },
    ] = useDeactivateMutation();

    useEffect(() => {
        if (!isPatchDeactivateEmployeeSuccess) {
            dispatch(setIsPatchDeactivateEmployeeSuccess(false));
        }
    }, [isPatchDeactivateEmployeeSuccess, dispatch]);

    useEffect(() => {
        if (!isPatchDeactivateEmployeeIsLoading) {
            dispatch(setIsPatchDeactivateEmployeeIsLoading(false));
        }
    }, [isPatchDeactivateEmployeeIsLoading, dispatch]);

    const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault();

        if (!deactivatedEmployee) {
            return;
        }

        deactivateEmployee(
            deactivatedEmployee.id,
            postEmployeeDeactivate,
            dispatch,
            establishmentId,
            outOfServiceDate,
        );
        dispatch(setIsDeactivateEmployeeConfirmationModalOpen(false));
    };

    return (
        <Popup
            className={"c-create-employee-modal"}
            title={"Medewerker uit dienst nemen"}
            onCloseClick={() => {
                dispatch(setIsDeactivateEmployeeConfirmationModalOpen(false));
            }}
        >
            <form className={"c-form"} onSubmit={handleSubmit}>
                <p>
                    Weet je zeker dat je {deactivatedEmployee?.user.first_name}{" "}
                    {deactivatedEmployee?.user.last_name} uit dienst wil nemen?
                </p>
                <DateInputFieldComponent
                    label={"Datum uit dienst"}
                    onDateChange={setOutOfServiceDate}
                    date={outOfServiceDate}
                    errorMessage={"Datum uit dienst is verplicht"}
                />
                <Button
                    variant={"alert"}
                    type={"submit"}
                    loading={isPatchDeactivateEmployeeIsLoading}
                    disabled={isPatchDeactivateEmployeeIsLoading}
                >
                    Medewerker uit dienst melden
                </Button>
            </form>
        </Popup>
    );
};
